import ESGTServiceDetail from "./ESGTServiceDetail";

export default ESGTServiceDetail;
